<template>
  <div class="TuPuLeftContainerClass"
       v-loading="loading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

      <div class="labelClass" v-if="labelShowText" :style="{ color: labelColor }">
        {{ labelShowText }}
      </div>
      <div class="searchClass">
        <el-input placeholder="请输入关键词，回车搜索" v-model="searchKey" @change="searchKeyEvent"></el-input>
      </div>
      <div id="bottomContainer" style="height: 100%;"></div>
  </div>
</template>

<script>
import userApi from "@/api/user";
import G6 from "@antv/g6";
export default {
  components: {

  },
  data() {
    return {
      labelShowText: "",
      labelColor: "",
      searchKey: "",
      globalGraph: null,
      initNodes: null,
      initEdges: null,
      nodeCaptions: null,
      edgeCaptions: null,
      nodeTitleInfoList: null,
      colors: ['#409eff','#bfebbc', '#5bb1a0', '#7f9fa9', '#91cc75', '#5470c6', '#fac858', '#14b3bc', '#37ffc9', '#ad94ff', '#73c0de', '#ee6666', '#3ba272', '#9a60b4', '#ea7ccc', '#91cc75', '#73c0de', '#ee6666'],//节点的填充颜色 目前写死
      centerNode: null,
      centerShow: false,
      labelShowStatus: false,
      lastEdges: null,
      lastNodes: null,
      loading: false,

    };
  },

  mounted() {
    this.getTopData();
  },

  methods: {
    searchKeyEvent() {
      userApi.getDataByNodeName({ key: this.searchKey }).then((res) => {
        this.renderCanvas(res.data);
      })
    },
    getTopData() {
      userApi.getTreeGraph().then((res) => {
        console.log("res",res);
        this.renderCanvas(res.data);
      })
    },
    renderCanvas(res) {
      if (this.globalGraph) {
        this.globalGraph.destroy()
      }
      this.initNodes = res.nodes
      this.initEdges = res.edges
      this.nodeCaptions = res.nodeCaptions
      this.edgeCaptions = res.edgeCaptions

      /**
       * 将边的id重新赋值 并且 将新的id和旧的id 映射为map 保存
       */
      let id = 345678 // 初始 ID
      let map = []
      res.edges.forEach((item) => {
        let newId = id++
        map.push({
          oldId: item.id,
          newId: newId
        })
        item.id = newId
      })

      let nodeLabels = {}
      res.nodes.forEach((item) => {
        if (nodeLabels[item.type]) {
          nodeLabels[item.type]++
        } else {
          nodeLabels[item.type] = 1
        }
      })

      this.nodeTitleInfoList = Object.entries(nodeLabels).map(([type, color]) => ({
        type,
        color
      }))

      this.nodeTitleInfoList.forEach((item, index) => {
        item.color = this.colors[index]
      })

      // 初始化G6显示
      let container = document.getElementById('bottomContainer');
      let width = container.scrollWidth;
      let height = container.scrollHeight;

      console.log(width,height);

      let graph = new G6.Graph({
        container,
        width,
        height,
        animate: false,
        modes: {
          default: ['zoom-canvas', 'drag-canvas', 'drag-node']
        },
        layout: {
          type: 'force', // 使用力导向布局
          preventOverlap: true, // 设置为 true 表示防止节点重叠
          linkDistance: 100, // 边的长度，也可以是一个函数，用于设置不同的边有不同的长度
          nodeStrength: -30, // 节点的斥力因子。正值表示节点之间的排斥力，负值表示节点之间的引力
          edgeStrength: 0.1, // 边的刚度系数。值越大，边越直。该值应在 [0, 1] 范围内
          kr: 10,
          nodeSize: 70,
          center: [container.scrollWidth / 2, container.scrollHeight / 2]
        },
        defaultNode: {
          size: 20
        }
      })

      this.nodeTitleInfoList.forEach((nodeInfo, index) => {
        res.nodes.forEach((node) => {
          if (node.type == nodeInfo.type) {
            node.label = node.name.length > 5 ? node.name.substring(0, 5) + '...' : node.name
            node.style = {
              fill: this.colors[index]
            }
            node.size = 40
            node.labelCfg = {
              position: 'center', // 其实默认就是 center，这里写出来便于理解
              style: {
                fontSize: 10, // 文本字体大小
                fill: '#000000' // 文本颜色
              }
            }
          }
        })
        res.edges.forEach((edge) => {
          edge.style = {
            stroke: '#6979a4',
            lineWidth: 2
          }
        })
      })

      graph.on('afterlayout', () => {
        const center = {
          x: graph.getWidth() / 2,
          y: graph.getHeight() / 2
        }
        let minDistance = Infinity
        let centralNode = null

        graph.getNodes().forEach((node) => {
          const model = node.getModel()
          const position = { x: model.x, y: model.y }
          const distance = Math.sqrt((position.x - center.x) ** 2 + (position.y - center.y) ** 2)

          if (distance < minDistance) {
            minDistance = distance
            centralNode = node
          }
        })

        if (centralNode) {
          this.centerNode = centralNode.getModel()
          this.centerShow = true
        }
      })

      graph.on('node:mouseenter', (ev) => {
        this.labelShowStatus = true
        let node = ev.item._cfg.model
        // labelShowText.value = rightBottomParse(node.type) + '：' + node.name
        this.labelShowText = node.name

        this.nodeTitleInfoList.forEach((item) => {
          if (item.type == node.type) {
            this.labelColor = item.color
          }
        })

        const relatedNodes = this.getRelatedNodes(node.id, graph.save()) // 获取一级和二级关联节点

        graph.getEdges().forEach((item) => {
          if (relatedNodes.includes(item._cfg.model.source) || relatedNodes.includes(item._cfg.model.target)) {
            graph.setItemState(item, 'highlight', true)
          } else {
            graph.hideItem(item._cfg.model.id)
          }
        })
      })

      graph.on('node:mouseleave', (ev) => {
        this.labelShowStatus = false
        let node = ev.item._cfg.model
        const relatedNodes = this.getRelatedNodes(node.id, graph.save()) // 获取一级和二级关联节点

        graph.getEdges().forEach((item) => {
          if (relatedNodes.includes(item._cfg.model.source) || relatedNodes.includes(item._cfg.model.target)) {
            graph.setItemState(item, 'highlight', false)
          } else {
            graph.showItem(item._cfg.model.id)
          }
        })
      })

      graph.on('node:click', (ev) => {
        let node = ev.item._cfg.model
        this.centerNode = node
      })

      graph.on('node:dblclick', (ev) => {
        let node = ev.item._cfg.model
        this.loading = true;
        this.nodeDbClickSearch(node.id)
      })

      this.lastNodes = res.nodes
      this.lastEdges = res.edges

      this.globalGraph = graph
      graph.data(res)
      graph.render()
      this.loading = false;

    },

    /**
     *  节点双击搜索
     * @param nodeId
     */
    nodeDbClickSearch(nodeId) {
      userApi.searchDataByNodeId({ id: nodeId }).then((res) => {
        console.log("res",res);
        res.data.edgeCaptions.forEach((edgeCaption) => {
          if (!this.edgeCaptions.includes(edgeCaption)) {
            this.edgeCaptions.push(edgeCaption)
          }
        })
        res.data.edges.forEach((edge) => {
          // 在 lastEdges 中查找是否有与当前 edge id 相同的对象
          // 如果在 lastEdges 中没有找到与当前 edge id 相同的对象，将当前 edge 添加到 lastEdges
          const existingEdge = this.lastEdges.find((lastEdge) => lastEdge.id == edge.id)
          if (!existingEdge) {
            this.lastEdges.push(edge)
          }
        })
        res.data.nodeCaptions.forEach((nodeCaption) => {
          if (!this.nodeCaptions.includes(nodeCaption)) {
            this.nodeCaptions.push(nodeCaption)
          }
        })
        res.data.nodes.forEach((node) => {
          // 在 lastNodes 中查找是否有与当前 node id 相同的对象
          // 如果在 lastNodes 中没有找到与当前 node id 相同的对象，将当前 node 添加到 lastNodes
          const existingNode = this.lastNodes.find((lastNode) => lastNode.id == node.id)
          if (!existingNode) {
            this.lastNodes.push(node)
          }
        })
        let newRes = {
          nodes: this.lastNodes,
          nodeCaptions: this.nodeCaptions,
          edges: this.lastEdges,
          edgeCaptions: this.edgeCaptions
        }

        console.log("newRes", newRes);
        this.renderCanvas(newRes)
      })
    },


    /**
     * 根据节点id再全部数据里面查找 1,2级的节点
     * @param nodeId
     * @param data
     */
    getRelatedNodes (nodeId, data) {
      const { nodes, edges } = data
      const oneStep = []
      const twoStep = []

      // 找到一级关系节点
      edges.forEach((edge) => {
        if (edge.source == nodeId) {
          oneStep.push(edge.target)
        }
        if (edge.target == nodeId) {
          oneStep.push(edge.source)
        }
      })
      // 找到二级关系节点
      oneStep.forEach((oneStepNodeId) => {
        edges.forEach((edge) => {
          if (edge.source == oneStepNodeId) {
            twoStep.push(edge.target)
          }
          if (edge.target == oneStepNodeId) {
            twoStep.push(edge.source)
          }
        })
      })

      // 合并一级和二级关系节点，并去重
      const relatedNodes = [...new Set([...oneStep, ...twoStep])]

      return relatedNodes
    }
  },
};
</script>

<style scoped>

.TuPuLeftContainerClass {
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.labelClass {
  position: absolute;
  top: 3%;
  left: 10%;
  color: #000000;
  max-width: 50%;
}

.searchClass {
  position: absolute;
  top: 3%;
  left: 76%;
  width: 22%;
}

>>> .searchClass {
  .el-input .el-input__inner{
    border: 1px solid #000000;
    color: #000000;
    background-color: transparent;
  }

  .el-input .el-input__inner::placeholder {
    color: #000000;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/Tupu/comp/LeftBottomTuPu.vue